module.exports = __webpack_public_path__ + "img/exante_cura_singolo.7e317efe.jpg";